
import { Component, Vue, Ref } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
// import { pick, pickBy } from 'lodash'
import pick from 'lodash/pick'
import pickBy from 'lodash/pickBy'
import { AppModule } from '@/store/modules/app'
import CompanyDetailForm from '../components/company_detail_form.vue'
import FullLoading from '@/components/full_loading/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'
// eslint-disable-next-line
import AvatarUpload, { AvatarUploadIns } from '@/components/avatar_upload/index.vue'
import DynamicTags from '@/components/dynamic_tags/index.vue'

const examineStatus = {
    ing: {
        value: 0, name: '审核中'
    },
    pass: {
        value: 1, name: '审核通过'
    },
    fail: {
        value: 2, name: '审核不通过'
    }
}

@Component({
    name: 'company-settle-detail',
    components: {
        CompanyDetailForm,
        FullLoading,
        CreateDetailLayout,
        RowWrap,
        RowItem,
        AvatarUpload,
        DynamicTags
    }
})
export default class extends Vue {
    @Ref('avatarRef') private avatarEl!: AvatarUploadIns
    private changeLoading = false
    private loading = true
    private companyId = ''
    private form: any = {}
    private company: any = { avatar: '', user: {} }
    private keywords: string[] = []
    private examineStatus = examineStatus

    get matchStatus() {
        const status = {
            [examineStatus.ing.value]: examineStatus.ing.name,
            [examineStatus.pass.value]: examineStatus.pass.name,
            [examineStatus.fail.value]: examineStatus.fail.name
        }
        // @ts-ignore
        return status[this.company.status]
    }

    private created() {
        this.companyId = this.$route.params.id
    }

    private async mounted() {
        this.$title('loading | 机构详情 - 庖丁')
        this.loading = true
        try {
            await AppModule.getIndustry()
            await this.getCompanyDetail()
        } catch (e) {
            console.error('加载机构详情失败:', e)
        } finally {
            this.loading = false
        }
    }

    /** 获取机构详情 */
    private async getCompanyDetail() {
        const params = {
            id: +this.companyId
        }
        const result = await EnterpriseService.getCompanySettleDetail(params)
        if (result.status === 200) {
            try {
                const data = result.data
                const industry = typeof data.industry === 'string' && data.industry ? JSON.parse(data.industry) : []
                let products: any[] = []
                if (typeof data.products === 'string' && data.products) {
                    try {
                        products = JSON.parse(data.products)
                    } catch (e) {
                        products = []
                    }
                } else if (Array.isArray(data.products)) {
                    products = data.products
                }
                const keywords = typeof data.keywords === 'string' && data.keywords ? JSON.parse(data.keywords) : []
                this.company = {
                    logo: data.logo,
                    user: data.user || {},
                    created_at: data.createdAt || data.created_at,
                    updated_at: data.updatedAt || data.updated_at,
                    status: data.status,
                    id: data.id,
                    user_id: data.userId || data.user_id
                }
                this.keywords = keywords
                this.form = {
                    ...data,
                    short_name: data.shortName || data.short_name || '',
                    official_url: data.officialUrl || data.official_url || '',
                    stock_code: data.stockCode || data.stock_code || '',
                    industry_ids: industry.length > 0 ? [industry[0]] : [],
                    products: products.map((n: any, i: number) => ({ ...n, key: `p${i}` })),
                    check: data.check !== undefined ? data.check : (data.status !== undefined ? data.status : 0)
                }
                this.$title(`${data.name}| 机构详情 - 庖丁`)
            } catch (e) {
                console.error('解析机构数据失败:', e)
            }
        }
    }

    private matchButtonType(status: number) {
        return this.company.status === status ? 'primary' : 'default'
    }

    private async changeStatus(status: number) {
        if (this.company.status === status) return
        this.changeLoading = true
        const params = {
            id: +this.companyId,
            status
        }
        const result = await EnterpriseService.updateCompanySettleStatus(params)
        this.changeLoading = false
        if (result.status === 200) {
            this.company.status = status
            return this.$message({
                showClose: true,
                type: 'success',
                message: '修改状态成功'
            })
        }
        this.$message({
            showClose: true,
            type: 'error',
            message: result.message || '发生错误, 修改状态失败'
        })
    }

}
